import React from 'react';
import SpeciesAndBreedsList from './SpeciesAndBreedsList';

function SpeciesAndBreeds() {
  return <SpeciesAndBreedsList />;
}

export default SpeciesAndBreeds;
